import SEO from "../components/SEO";
import CTAStrip from "../components/CTAStrip";
import { IMG } from "../data/site";

const REALISATIONS = [
    {
        title: "Double portillon aluminium ajouré",
        city: "Ferney-Voltaire",
        materials: "Aluminium thermolaqué anthracite, lames laser",
        feature: "Deux portillons assortis avec serrures inox, accès jardin",
        img: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/0ne7hwk9_claustra.png",
    },
    {
        title: "Brise-vue façade contemporaine",
        city: "Annemasse",
        materials: "Lames aluminium verticales anthracite",
        feature: "Brise-vue intégré au bardage sur trois niveaux de balcons",
        img: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/woibvc2a_Bariere.png",
    },
    {
        title: "Carport & claustra aluminium",
        city: "Saint-Genis-Pouilly",
        materials: "Panneaux perforés aluminium anthracite",
        feature: "Carport avec claustra latéral et accès sécurisé",
        img: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/fc4w4046_claurstra%20.png",
    },
    {
        title: "Garde-corps de terrasse villa",
        city: "Divonne-les-Bains",
        materials: "Acier thermolaqué noir, barreaudage vertical",
        feature: "Pose sur muret béton, finition extérieure haut de gamme",
        img: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/f6h7q5cr_cloture.png",
    },
    {
        title: "Garde-corps d'escalier intérieur",
        city: "Saint-Julien-en-Genevois",
        materials: "Acier laqué brun, barreaudage horizontal sur mesure",
        feature: "Sur mesure pour escalier marbre, finition résidentielle",
        img: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/mki3hj83_bari%C3%A8re.png",
    },
    {
        title: "Portail aluminium — entrée moderne",
        city: "Gex",
        materials: "Aluminium thermolaqué anthracite, lames horizontales",
        feature: "Portail battant 2 vantaux avec visiophone intégré",
        img: IMG.gateAlu,
    },
    {
        title: "Échelle à crinoline (norme EN 14122)",
        city: "Genève",
        materials: "Acier laqué noir, fixations murales renforcées",
        feature: "Accès toiture sécurisé pour bâtiment professionnel",
        img: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/01wxzwd8_Echelle.png",
    },
    {
        title: "Garde-corps acier sur mesure",
        city: "Nyon",
        materials: "Acier laqué noir mat, barreaudage vertical",
        feature: "Garde-corps d'escalier contemporain, finition villa",
        img: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/fyduh1x9_garde%20corp.png",
    },
    {
        title: "Ferronnerie d'art — palier d'étage",
        city: "Thoiry",
        materials: "Fer forgé noir, motifs torsadés et feuilles",
        feature: "Garde-corps de mezzanine, style classique résidentiel",
        img: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/kcuxczfl_feronerie.png",
    },
    {
        title: "Rambarde d'escalier sur mesure",
        city: "Prévessin-Moëns",
        materials: "Acier thermolaqué noir, profilés plats verticaux",
        feature: "Pose sur escalier marbre, design contemporain",
        img: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/geep4heg_escalier%20rembarde.png",
    },
    {
        title: "Métallerie extérieure — local technique",
        city: "Crozet",
        materials: "Cadre acier laqué anthracite, panneaux grillagés",
        feature: "Sécurisation d'un local technique avec auvent intégré",
        img: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/zh05kwog_metallerie.png",
    },
    {
        title: "Portail coulissant motorisé",
        city: "Cessy",
        materials: "Aluminium anthracite, moteur silencieux",
        feature: "Coulissant 4 m motorisé avec digicode et télécommandes",
        img: IMG.motor,
    },
    {
        title: "Portail fer forgé d'exception",
        city: "Ornex",
        materials: "Fer forgé noir avec motifs cuivrés et fleurons",
        feature: "Portail battant 2 vantaux entre piliers, finition haut de gamme",
        img: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/g0m207ek_portail%20forg%C3%A9.png",
    },
    {
        title: "Portail battant 3 vantaux ajouré",
        city: "Saint-Jean-de-Gonville",
        materials: "Aluminium thermolaqué anthracite, lames laser",
        feature: "Portail battant grande largeur, ouverture vers l'intérieur",
        img: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/5zx87gnv_portailA.png",
    },
    {
        title: "Portail coulissant grande largeur",
        city: "Versoix",
        materials: "Aluminium anthracite, lames horizontales ajourées",
        feature: "Coulissant 4 panneaux avec rail au sol, accès véhicules",
        img: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/fg6n2r5o_portail.png",
    },
    {
        title: "Portail aluminium — pose en cours",
        city: "Sergy",
        materials: "Aluminium thermolaqué anthracite, lames ajourées",
        feature: "Portail battant 3 vantaux, scellement et alignement en chantier",
        img: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/h3n02zaa_Portal.png",
    },
    {
        title: "Portail battant 4 vantaux design",
        city: "Coppet",
        materials: "Aluminium thermolaqué anthracite, lames verticales",
        feature: "Portail battant 4 vantaux avec portillon intégré et interphone",
        img: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/uy2vfa4b_portail3.jpg",
    },
    {
        title: "Brise-vue laser motif tropical",
        city: "Founex",
        materials: "Aluminium thermolaqué anthracite, découpe laser feuillage",
        feature: "Panneau design entre piliers bois, terrasse extérieure",
        img: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/m3xt4s9u_brise%20vu.JPG",
    },
    {
        title: "Portail acier classique provençal",
        city: "Rolle",
        materials: "Acier noir thermolaqué, pointes de lance forgées",
        feature: "Portail battant 2 vantaux, motorisation Came avec feu orange",
        img: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/rhg1n7f9_portail%20acier.png",
    },
    {
        title: "Portail aluminium horizontal premium",
        city: "Gland",
        materials: "Aluminium thermolaqué anthracite, lames mixtes plein/ajouré",
        feature: "Portail battant 2 vantaux motorisé, finition villa",
        img: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/xwqf21pn_portailalu.png",
    },
    {
        title: "Portillon design quadrillé",
        city: "Morges",
        materials: "Acier thermolaqué anthracite, motif géométrique sur mesure",
        feature: "Portillon piétonnier entre piliers, boîte aux lettres intégrée",
        img: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/9bexeduj_portillon.png",
    },
    {
        title: "Clôture aluminium occultante",
        city: "Mies",
        materials: "Lames aluminium horizontales pleines, anthracite",
        feature: "Clôture occultante de jardin avec portillon assorti",
        img: "https://customer-assets.emergentagent.com/job_leman-portails/artifacts/qll237lc_coulissant.png",
    },
];

export default function Realisations() {
    return (
        <>
            <SEO
                title="Réalisations de portails, clôtures et brise-vue autour du Léman"
                description="Découvrez nos chantiers récents de portails, clôtures et brise-vue à Genève, dans le Pays de Gex et en Haute-Savoie."
                keywords={["réalisations portail", "chantier portail Genève", "portail motorisé Pays de Gex"]}
            />
            <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-20 pb-12">
                <div className="divider-tag mb-6">Galerie</div>
                <h1 className="font-display text-4xl md:text-6xl text-white leading-[1.05] tracking-tight max-w-4xl">
                    Nos réalisations de portails,<br />
                    <span className="italic text-white/80">clôtures et brise-vue.</span>
                </h1>
                <p className="mt-6 text-white/65 max-w-3xl">
                    Une sélection de chantiers récents autour de Genève, du Pays de Gex et de la Haute-Savoie. Chaque projet est conçu sur mesure, avec une exigence de finition constante.
                </p>
            </section>

            <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-20 md:pb-28">
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
                    {REALISATIONS.map((r, i) => (
                        <article key={i} className="card-product group" data-testid={`realisation-${i}`}>
                            <div className="img-wrap aspect-[4/5]">
                                <img src={r.img} alt={r.title} className="w-full h-full object-cover" loading="lazy" />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#0A1118] via-transparent" />
                            </div>
                            <div className="p-6">
                                <div className="text-[10px] tracking-[0.28em] uppercase text-brand-accent/80 mb-2">{r.city}</div>
                                <div className="font-display text-xl text-white">{r.title}</div>
                                <div className="mt-3 text-xs text-white/55 space-y-1">
                                    <div><span className="text-white/35">Matériaux : </span>{r.materials}</div>
                                    <div><span className="text-white/35">Particularité : </span>{r.feature}</div>
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            </section>

            <CTAStrip title="Votre projet, notre prochain chantier ?" />
        </>
    );
}
